import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useBookmakerTypeCount = () => {
  const bookmakers = useBookmakersAll();

  const exchangeCount = useMemo(
    () => bookmakers?.filter(({ type }) => type.toLowerCase() === 'exchange').length,
    [bookmakers],
  );

  const sportsbookCount = useMemo(
    () => bookmakers?.filter(({ type }) => type.toLowerCase() === 'traditional').length,
    [bookmakers],
  );

  return useMemo(() => ({ exchangeCount, sportsbookCount }), [exchangeCount, sportsbookCount]);
};
